export class SystemParam {
  id?: number;
  code: string;
  description?: string;
  value?: any;
}
